import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 7h20v11H2V7Zm6 2h3v4h2V9h3v3h2V9h2v7H4V9h2v3h2V9Z"
    />
  </svg>
);
export default IconRulerStrokedSizeM;
